module.exports = __webpack_public_path__ + "static/media/star-purple-border.b88ad1d9.svg";